export default __webpack_public_path__ + "static/N0033-1923175f072d50011ce5bd02c30b1a21.png";